import { createSelector } from '@reduxjs/toolkit';
import { EditIcon } from 'evergreen-ui';
import { dcpcApi } from './dcpcApi';
import { getToasterError } from '../utils';
import { CHANNEL_TYPE_PARAMS_MUTATION_TAG } from './channelTypeParamsApi';
import { CHANNELS_TAG } from './channelsApi';

const CHANNEL_TYPES_TAG = 'ChannelTypes';

dcpcApi.enhanceEndpoints({ addTagTypes: [CHANNEL_TYPES_TAG] });
const channelTypesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getChannelTypes: builder.query({
      query: () => 'channel-types',
      providesTags: [CHANNEL_TYPES_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'типа канала', 'channelTypes');
        }
      },
    }),
    getChannelTypeById: builder.query({
      query: (id) => `channel-types/${id}`,
      providesTags: [CHANNEL_TYPES_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'типа канала', 'channelTypes');
        }
      },
    }),
    updateChannelType: builder.mutation({
      query: ({ id, body }) => ({
        url: `channel-types${id ? `/${id}` : ''}`,
        method: id ? 'PUT' : 'POST',
        body,
      }),
      invalidatesTags: [CHANNEL_TYPES_TAG],
    }),

    getChannelsByChannelTypeId: builder.query({
      query: (id) => `channel-types/${id}/channels`,
      providesTags: [CHANNEL_TYPES_TAG, CHANNELS_TAG],
    }),
    getChannelTypeWithChannels: builder.query({
      query: (id) => `channel-types/${id}/channels`,
      providesTags: [CHANNEL_TYPES_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'типа канала', 'channelTypes');
        }
      },
    }),
    getChannelTypeParamsByChannelTypeId: builder.query({
      query: (id) => `channel-types/${id}/params`,
      providesTags: [CHANNEL_TYPE_PARAMS_MUTATION_TAG],
    }),
  }),
});

export const {
  useGetChannelTypeByIdQuery,
  useUpdateChannelTypeMutation,
  useGetChannelTypesQuery,
  useGetChannelTypeWithChannelsQuery,
  useGetChannelTypeParamsByChannelTypeIdQuery,
  useLazyGetChannelTypeWithChannelsQuery,

  useLazyGetChannelTypeByIdQuery,

  useGetChannelsByChannelTypeIdQuery,
} = channelTypesApi;

export const channelTypesSelect = (state) => channelTypesApi.endpoints.getChannelTypes.select()(state);
export const channelTypesSelector = (state) => channelTypesSelect(state).data || [];

const filterChannelTypesBySearchTextSelector = createSelector(
  channelTypesSelector,
  (_, searchText) => searchText,
  (channelTypes, searchText) => ({
    columns: [
      {
        label: 'Код',
      },
      {
        label: 'Описание',
      },
    ],
    rows: channelTypes.reduce((acc, cur) => {
      const {
        id, kod, description,
      } = cur;
      const row = [id, kod, description].map((v) => v || '');
      if (row.filter((v, idx) => idx !== 0 && v !== null && v.toUpperCase().includes(searchText.toUpperCase())).length > 0) {
        acc.push(row);
      }
      return acc;
    }, []),
    rowButtons: [
      {
        label: 'Редактировать',
        to: (id) => `${id}`,
        icon: EditIcon,
      },
    ],
    createLink: {
      label: 'Создать тип канала',
    },
  }),
);

export const channelTypesBySearchTextSelector = (searchText) => (state) => filterChannelTypesBySearchTextSelector(state, searchText);
